<template>
  <div
    v-testid="{ id: 'basket-plus-savings-banner-region', key: petId }"
    class="plus-savings-banner"
    role="region"
    :aria-labelledby="headlineId"
  >
    <h3 :id="headlineId" class="plus-savings-banner__headline">
      {{ $t('basketPlusSavingsBanner.headline', { petName: petName }) }}
    </h3>
    <div class="plus-savings-banner__body">
      {{ $t('basketPlusSavingsBanner.body') }}
      <b-link
        v-testid="{ id: 'basket-plus-savings-banner-store-action', key: petId }"
        :href="storeUrl"
        class="plus-savings-banner__link"
        @click="trackClick"
        >{{ $t('basketPlusSavingsBanner.shopNow') }}</b-link
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { pushAnalyticsEvent } from '@/utils/analytics';

const BANNER_SOURCE = 'basket_banner';

export default {
  name: 'PlusSavingsBanner',
  props: {
    petId: {
      type: [String, Number],
      required: true,
    },
    petName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ generateFullUrl: 'generateFullUrl' }),
    headlineId() {
      return `plus-savings-banner-headline-${this.petId}`;
    },
    storeUrl() {
      return `${this.generateFullUrl('/store')}?source=${BANNER_SOURCE}`;
    },
  },
  mounted() {
    pushAnalyticsEvent('plus_savings_banner_impression', { banner_source: BANNER_SOURCE });
  },
  methods: {
    trackClick() {
      pushAnalyticsEvent('plus_savings_banner_click', { banner_source: BANNER_SOURCE });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';

.plus-savings-banner {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.875rem 1rem;
  background-color: $amber-300;
  color: $sky-900;

  &__headline {
    margin: 0;
    font-size: 0.875rem;
    font-weight: 700;
  }

  &__body {
    font-size: 0.8125rem;
    line-height: 1.45;
  }

  &__link {
    font-weight: 700;
    color: inherit;
    text-decoration: underline;

    &:hover {
      color: $sky-800;
    }
  }
}
</style>
